module.exports = __webpack_public_path__ + "static/media/2020.4.16老街乱拉线联席会议.80d941b3.jpg";